module.exports = __webpack_public_path__ + "static/media/serbia-flag.949c17e2.png";